import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import methodModel from '../../methods/methods';
import Layout from '../../components/global/layout';

const Menudetail = () => {
  const history = useNavigate();
  const { id, userId } = useParams();
  const [data, setData] = useState();
  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`items`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            // to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              View Menu Item
            </h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about your Menu Item
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Name</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {methodModel.capitalizeFirstLetter(data?.name)}
            </div>
          </div>

          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Url</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data?.url}
            </div>
          </div>





        </div>
      </div>
    </Layout>
  );
};
export default Menudetail;
